module.exports = __webpack_public_path__ + "static/media/wpm.3501b6d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/wpm.png
// module id = 320
// module chunks = 0